import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


document.addEventListener('DOMContentLoaded', () => {

    const socialProofSection = document.getElementById('social-proof-section');

    if (socialProofSection) {

        gsap.set('.number-item', {
            opacity: 0,
            y: "-40"
        })

        gsap.set('.number-title', {
            opacity: 0,
            y: "3"
        })

        ScrollTrigger.batch('.numbers-block', {
            onEnter: (blocks) => {
                blocks.forEach((numberBlock, index) => {
                    const numberItems = numberBlock.querySelectorAll('.number-item');
                    const title = numberBlock.querySelector('.number-title');

                    const tl = gsap.timeline({
                        delay: index * 0.5,
                    });

                    tl.to(numberItems, {
                        y: "0",
                        duration: 0.3,
                        opacity: 1,
                        stagger: 0.15,
                    })

                    .to(title, {
                            y: "0",
                            duration: 0.3,
                            opacity: 1,
                        }, "-=0.2")
                    // Then animate numbers with stagger


                });
            },
            start: "top 80%",
            once: true,
        });

    }
});